import React from 'react';
import CustomModal from '../CustomModal/CustomModal';
import LoginFirstModalContent from './LoginFirstModalContent';
import { useDispatch, useSelector } from 'react-redux';
import { setLoginFirstModalOpen } from '../../../store/slices/common/commonSlice';
import Loader from '../Loader/Loader';

const LoginFirstModal = ({ title }) => {
  const dispatch = useDispatch();
  const loginFirstModalOpen = useSelector(
    ({ common }) => common?.loginFirstModalOpen
  );

  const fetchingUserDetails = useSelector(({ userProfile }) => {
    return userProfile?.loading;
  });
  return (
    <CustomModal
      modalOpen={loginFirstModalOpen}
      setModalOpen={(value) => {
        dispatch(setLoginFirstModalOpen(value));
      }}
    >
      {fetchingUserDetails ? (
        <Loader />
      ) : (
        <LoginFirstModalContent title={title} />
      )}
    </CustomModal>
  );
};

export default LoginFirstModal;
